import { render, staticRenderFns } from "./ParallelogramViz.vue?vue&type=template&id=5d4f398c&scoped=true"
import script from "./ParallelogramViz.vue?vue&type=script&lang=js"
export * from "./ParallelogramViz.vue?vue&type=script&lang=js"
import style0 from "./ParallelogramViz.vue?vue&type=style&index=0&id=5d4f398c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f398c",
  null
  
)

export default component.exports